import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage, FormattedDate } from 'react-intl'
import _ from 'lodash'

import { LOCALE_PREFIX } from './constants'

import ProgressBar from '../ProgressBar'
import FormattedNumber from '../../../../../../../../services/translations/components/FormattedNumber'

import hocConnect from './hocConnect'
import hocLoader from '../Loader/hocLoader'

import './style.scss'

@injectIntl
@hocLoader
@hocConnect
export default class GeneralSettings extends Component {
    static propTypes = {
        distraints: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        isLoading: PropTypes.bool.isRequired,
        license: PropTypes.object.isRequired,
        linkages: PropTypes.object,
        loadContent: PropTypes.func.isRequired,
        monitoring: PropTypes.object,
        portfolio: PropTypes.object,
        report: PropTypes.object,
        user: PropTypes.object.isRequired,
    }

    componentDidMount() {
        const { id, isLoading, loadContent } = this.props

        if (!isLoading) loadContent(id)
    }

    renderReport = () => {
        const { report } = this.props

        if (!report) return null

        const message = (
            <FormattedMessage
                id={`${LOCALE_PREFIX}.limits.period.${report.period}`}
                values={{ total: report.total, b: (chunks) => <b>{chunks}</b> }}
            />
        )

        return (
            <div className={'row'}>
                <div className={'left'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.limits.report`} />
                </div>
                <div className={'right'}>
                    <ProgressBar value={report.value} total={report.total} message={message} />
                </div>
            </div>
        )
    }

    renderLinkages = () => {
        const { linkages } = this.props

        if (!linkages) return null

        const message = (
            <FormattedMessage
                id={`${LOCALE_PREFIX}.limits.period.${linkages.period}`}
                values={{ total: linkages.total, b: (chunks) => <b>{chunks}</b> }}
            />
        )

        return (
            <div className={'row'}>
                <div className={'left'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.limits.linkages`} />
                </div>
                <div className={'right'}>
                    <ProgressBar value={linkages.value} total={linkages.total} message={message} />
                </div>
            </div>
        )
    }

    renderMonitoring = () => {
        const { monitoring } = this.props

        if (!monitoring) return null

        const messageSubjects = (
            <FormattedMessage
                id={`${LOCALE_PREFIX}.limits.monitoring.subjects`}
                values={{ count: monitoring.subjects.total, b: (chunks) => <b>{chunks}</b> }}
            />
        )
        const messageGroups = (
            <FormattedMessage
                id={`${LOCALE_PREFIX}.limits.monitoring.groups`}
                values={{ count: monitoring.groups.total, b: (chunks) => <b>{chunks}</b> }}
            />
        )

        const noSubjectMessage = <FormattedMessage id={`${LOCALE_PREFIX}.limits.monitoring.noSubjects`} />

        return (
            <div className={'row'}>
                <div className={'left'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.limits.monitoring`} />
                </div>
                <div className={'right'}>
                    {monitoring.subjects.total > 0 && monitoring.subjects.total > 0 ? (
                        <div>
                            <ProgressBar
                                value={monitoring.subjects.value}
                                total={monitoring.subjects.total}
                                message={messageSubjects}
                            />
                            <ProgressBar
                                value={monitoring.groups.value}
                                total={monitoring.groups.total}
                                message={messageGroups}
                            />
                        </div>
                    ) : (
                        noSubjectMessage
                    )}
                </div>
            </div>
        )
    }

    renderPortfolio = () => {
        const { portfolio } = this.props

        if (!portfolio) return null

        const message = (
            <FormattedMessage
                id={`${LOCALE_PREFIX}.limits.period.year`}
                values={{ total: portfolio.total, b: (chunks) => <b>{chunks}</b> }}
            />
        )
        const name = _.trim(_.replace(portfolio.name, 'Gnosus', ''))

        return (
            <div className={'row'}>
                <div className={'left'} style={{ textTransform: 'capitalize' }}>
                    {name}
                </div>
                <div className={'right'}>
                    <ProgressBar value={portfolio.value} total={portfolio.total} message={message} />
                </div>
            </div>
        )
    }

    renderDistraint = (country) => {
        const { distraints } = this.props

        const moneyAvailable = (
            <FormattedNumber
                value={distraints[country].moneyLeft}
                style={'currency'} // eslint-disable-line react/style-prop-object
                currency={_.toUpper(distraints[country].moneyLeftCurrency)}
            />
        )

        const moneyPerQuery = (
            <FormattedNumber
                value={distraints[country].pricePerQuery}
                style={'currency'} // eslint-disable-line react/style-prop-object
                currency={_.toUpper(distraints[country].pricePerQueryCurrency)}
            />
        )

        const validTo = distraints[country].validTo

        return (
            <div className={'row'}>
                <div className={'left'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.limits.distraints.${country}`} />
                </div>
                <div className={'right'}>
                    <div>
                        <FormattedMessage id={`${LOCALE_PREFIX}.limits.distraints.availableBalance`} />
                        <span className={'text bold'}>{moneyAvailable}</span>
                    </div>
                    <div>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.limits.distraints.queries`}
                            values={{ queries: _.floor(distraints[country].queriesLeft) }}
                        />
                        <span className={'text'}>{moneyPerQuery}</span>
                    </div>
                    {validTo && (
                        <div>
                            <FormattedMessage id={`${LOCALE_PREFIX}.limits.distraints.valid`} />
                            <span className={'text'}>
                                <FormattedDate value={validTo} />
                            </span>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    renderDistraints = () => {
        const { distraints } = this.props

        if (!distraints) return null

        return (
            <div>
                {this.renderDistraint('cz')}
                {this.renderDistraint('sk')}
            </div>
        )
    }

    render() {
        const { user, license, intl } = this.props

        const licenseProgressBarText = (
            <FormattedMessage
                id={`${LOCALE_PREFIX}.license.remains`}
                values={{
                    date: intl.formatDate(new Date(license.end)),
                    remain: license.remainDays,
                    b: (chunks) => <b>{chunks}</b>,
                }}
            />
        )

        return (
            <div className={'content-general-settings'}>
                <div className={'header'}>
                    <div className={'name'}>{user.name}</div>
                    <div className={'email'}>{user.email}</div>
                </div>
                <div className={'licences'}>
                    <div className={'title'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.license.title`} />
                    </div>
                    <div className={'row'}>
                        <div className={'left'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.license.type`} />
                        </div>
                        <div className={'right'}>{license.name}</div>
                    </div>
                    <div className={'row'}>
                        <div className={'left'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.license.access`} />
                        </div>
                        <div className={'right'}>
                            <ProgressBar
                                value={license.usedDays}
                                total={license.totalDays}
                                hasLabel={false}
                                threshold={80}
                                message={licenseProgressBarText}
                            />
                        </div>
                    </div>
                </div>
                <div className={'limits'}>
                    <div className={'title'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.limits.title`} />
                    </div>
                    {this.renderReport()}
                    {this.renderLinkages()}
                    {this.renderMonitoring()}
                    {this.renderPortfolio()}
                    {this.renderDistraints()}
                </div>
            </div>
        )
    }
}
